<template>
  <v-dialog v-model="dialog" width="1200px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Stock.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="stockKeyword"
              @text="KeyWord = $event"
              :label="$t('Stock.Fields.stock_name') + ' / ' + $t('Stock.Fields.stock_code')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherStockDistrict v-model="stockDistrictSelected" />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Material.choose") }}
            </div>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("CRUD.choosed") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("CRUD.unchoose") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="stockItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              stocks.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.type="{ item, index }">
          <span :v-resize="!index ? $stickTableResizer() : null"> </span>
          <v-chip v-if="item.type == 0" small label>
            {{ $t("Stock.type.real") }}
          </v-chip>
          <v-chip v-if="item.type == 1" small label>
            {{ $t("Stock.type.v_auto") }}
          </v-chip>
          <v-chip v-if="item.type == 2" small label>
            {{ $t("Stock.type.v_manual") }}
          </v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            small
            label
            :color="item.status | stockStatusColor"
            :text-color="item.status | stockStatusTextColor"
          >
            {{ item.status | stockStatusText }}
          </v-chip>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Stocks from "@/api/stocks";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStockDistrict from "@/components/plugins/SearcherStockDistrict";

export default {
  name: "StocksSelectsDialog",

  props: {
    fullField: Boolean,
    value: Boolean,
    changed: Array,
    stockIds: Array,
    options: Object,
    disabledIds: Array,
    types: Array,
    status: Array,
    notWMS: Boolean
  },

  components: {
    SearcherKeyword,
    SearcherStockDistrict,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Stock.Fields.stock_code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("Stock.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Stock.Fields.stock_manager"),
          align: "start",
          sortable: false,
          value: "manager",
        },
        {
          text: i18n.t("Stock.Fields.tel"),
          align: "start",
          sortable: false,
          value: "tel",
        },
        {
          text: i18n.t("Stock.Fields.type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("Stock.Fields.memo"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "memo",
        },
        {
          text: i18n.t("Stock.Fields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    stockItems() {
      //前端搜索
      return this.stocks.filter(
        (item) =>
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          ((this.stockDistrictSelected && item.stock_district.id == this.stockDistrictSelected.id) || !this.stockDistrictSelected) &&
          ((this.stockKeyword && (item.name.indexOf(this.stockKeyword) > -1) || item.code.indexOf(this.stockKeyword) > -1) ||
            !this.stockKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    stocks: [],
    stockKeyword: "",
    stockDistrictSelected: null,
    chooseFlgs: [0],
    itemsPerPageOptions: 10,
    stockIdsChoosed: [],
    stockIdsDisabled: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取供应商列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.stockKeyword = this.KeyWord;
    },

    //获取供应商列表
    getStocksFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.stocks = this.stocks.map((stock) => {
          if (
            this.stockIdsChoosed.indexOf(stock.id) > -1 &&
            (!stock.choose || !stock.disabled)
          ) {
            stock = Object.assign({}, stock, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.stockIdsChoosed.indexOf(stock.id) == -1 &&
            (stock.choose == 1 || stock.disabled)
          ) {
            if (stock.choose == 1) {
              stock.choose = 0;
            }
            if (stock.disabled) {
              stock.disabled = false;
            }
          }
          if (this.stockIdsDisabled.indexOf(stock.id) > -1) {
            stock.disabled = true;
          }

          return stock;
        });
        return;
      }

      let options = this.options;
      if (!this.fullField) {
        var fieldFilter = [
          "id",
          "code",
          "name",
          "type",
          "status",
          "StockDistrict.id"
        ];
        options = Object.assign(
            {
              fieldFilter: fieldFilter,
              // 仅筛选少许必要字段
            },
            this.options
        );
      }
      if (this.types && this.types.length) {
        options = Object.assign({}, options, { types: this.types });
      }
      if (this.status && this.status.length) {
        options = Object.assign({}, options, { status: this.status });
      }
      if (this.notWMS) {
        options = Object.assign({}, options, {wms_setting: 0})
      }

      Stocks.fetchAllNoPaging(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = response.data.stocks.map((stock) => {
              //默认勾选
              if (this.stockIdsChoosed.indexOf(stock.id) > -1) {
                stock = Object.assign({}, stock, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (stock.choose == 1 || !stock.choose) {
                  stock.choose = 0;
                }
                if (stock.disabled) {
                  stock.disabled = false;
                }
              }
              if (this.stockIdsDisabled.indexOf(stock.id) > -1) {
                stock.disabled = true;
              }
              return stock;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          if (this.stockIds && this.stockIds.length) {
            this.stockIdsChoosed = JSON.parse(
              JSON.stringify(this.stockIds)
            );
          } else {
            this.stockIdsChoosed = [];
          }
          if (this.disabledIds && this.disabledIds.length) {
            this.stockIdsDisabled = JSON.parse(
              JSON.stringify(this.disabledIds)
            );
          }

          this.choosedLength = this.stockIdsChoosed.length;
          this.getStocksFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.stockKeyword = "";
          this.stockDistrictSelected = null;
          this.chooseFlgs = [0];
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.stocks = this.stocks.map(
          function (e) {
            var item = this.stockItems.find((m) => m.id == e.id && !e.disabled);
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    stocks: {
      deep: true,
      handler() {
        //整理新增商品
        this.stocks.forEach((stock) => {
          if (
            stock.choose &&
            !this.stockIdsChoosed.includes(stock.id) &&
            !this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == stock.id
            )
          ) {
            this.newChoosedArr.push(stock);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !stock.choose &&
            this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == stock.id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) =>
                  new_choosed.id == stock.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>